import { render, staticRenderFns } from "./buy.vue?vue&type=template&id=6653b948&scoped=true"
import script from "./buy.vue?vue&type=script&lang=js"
export * from "./buy.vue?vue&type=script&lang=js"
import style0 from "./buy.vue?vue&type=style&index=0&id=6653b948&prod&lang=less&scoped=true"
import style1 from "./buy.vue?vue&type=style&index=1&id=6653b948&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6653b948",
  null
  
)

export default component.exports